export type Screen = 'sign-in' | 'companies' | 'signed-out'

export const COMPANIES_SEGMENT = 'companies'

function withTrailingSlash(base: string): string {
  return base.endsWith('/') ? base : `${base}/`
}

export function resolveScreen(pathname: string, base: string): Screen {
  const path = pathname.split(/[?#]/)[0]
  const prefix = withTrailingSlash(base)
  const rest = path.startsWith(prefix) ? path.slice(prefix.length) : path.replace(/^\/+/, '')

  if (path.startsWith(prefix) && /^signed-out\/?$/.test(rest)) {
    return 'signed-out'
  }

  return rest.split('/')[0] === COMPANIES_SEGMENT ? 'companies' : 'sign-in'
}
